import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons, showToast } from "deskera-ui-library";
import Stepper from "../common/Stepper";
import LandingPageManager from "./LandingPageManager";
import SharePopup from "../common/SharePopup";
import LandingPageService from "../../services/landingPage";

/*
PROPS
- stepperIndex
- title
- onSave
*/

class LandingPageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needSharePopup: false,
      isActive: LandingPageManager.getPageStatus(),
    };
  }
  render() {
    return (
      <div className="parent-width border-box column position-relative z-index-2">
        <div className="row justify-content-between">
          <DKLabel text={this.props.title} className="fw-m fs-l" />
          {this.getButtons()}
        </div>
        <div className="row justify-content-center">
          <Stepper
            data={LandingPageManager.getAllCreationSteps()}
            currentIndex={this.props.stepperIndex ? this.props.stepperIndex : 0}
          />
        </div>
      </div>
    );
  }

  getButtons() {
    return (
      <div className="row" style={{ width: "auto" }}>
        {/* <DKLabel text="Active" />
        <Toggle
          isOn={this.state.isActive}
          color="bg-app"
          className="ml-s"
          onChange={() => {
            this.setState({ isActive: !this.state.isActive }, () => {
              this.updateStatus();
            });
          }}
        /> */}

        {LandingPageManager.isPageDataAvailable() && (
          <DKButton
            title="Share"
            className="bg-white border-m ml-r unselectable"
            icon={DKIcons.ic_share}
            onClick={() => {
              this.showSharePopup();
            }}
          />
        )}

        {this.props.onSave && (
          <DKButton
            title="Save & Proceed"
            className="bg-app text-white ml-r unselectable"
            onClick={() => {
              this.props.onSave();
            }}
          />
        )}
        {this.state.needSharePopup && this.getSharePopup()}
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSharePopup() {
    return (
      <SharePopup
        style={{ top: 35, right: 0 }}
        // embedCode='<iframe frameborder="0" style="height:500px;width:99%;border:none;" src="https://forms.deskera.com/form/ContentMarketingWorkshop/formperma/V0HqLCXF3AC0zw4BjDaqAgGZMtFQrRWkHU0hTwUJSj0"></iframe>'
        directLink={LandingPageManager.getDirectLink()}
        onClose={this.hideSharePopup}
      />
    );
  }

  showSharePopup = () => {
    this.setState({ needSharePopup: true });
  };

  hideSharePopup = () => {
    this.setState({ needSharePopup: false });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  updateStatus() {
    const request = LandingPageManager.getRequestToUpdateStatus(
      this.state.isActive
    );
    LandingPageService.update(
      request,
      LandingPageManager.getPageRecordId(),
      (data) => {
        showToast("Status updated!", "success");
      },
      (error) => {}
    );
  }
}

export default LandingPageHeader;
